import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import NumberField from 'components/number-field';
import { UpdateScenarioFinancialDataInput } from 'views/bluviu-nutrition/features/scenarios-v2/types/update-scenario-financial-data-input.type';
import { useIntl } from 'react-intl';

const ProductionCostSection: React.FC = () => {
  const { control } = useFormContext<UpdateScenarioFinancialDataInput>();
  const intl = useIntl();

  const productionCostFields = [
    {
      label: 'Product cost / week',
      name: 'productionCostPerWeekPerCage',
      endAdornment: '/ week per cage',
    },
    {
      label: 'Harvest cost / kg',
      name: 'harvestCostPerKg',
      endAdornment: '/ kg harvested',
    },
    {
      label: 'Smolt cost / smolt',
      name: 'smoltCostPerSingleSmolt',
      endAdornment: '/ smolt',
    },
  ];

  return (
    <Box display={'grid'} gridTemplateColumns={'repeat(2,1fr)'} gap={4}>
      {productionCostFields.map((field) => (
        <NumberField
          key={field.name}
          dark
          label={field.label}
          fullWidth
          decimalScale={3}
          endAdornment={field.endAdornment}
          controller={{
            control,
            name: field.name,
            rules: {
              required: intl.formatMessage({ id: 'form.rules.required' }),
              validate: {
                greaterThanZero: (value) => (value > 0 ? true : intl.formatMessage({ id: 'form.rules.moreThanZero' })),
              },
            },
          }}
        />
      ))}
    </Box>
  );
};

export default ProductionCostSection;
